import { useHttpClient } from "@/common/api/httpClient";
import type { LogSorterResponse } from "./common/logSorterResponse";
import { useLanguageStore } from "shared/translations/stores/languageStore";
import { storeToRefs } from "pinia";


export interface GetLogSortersSuccessResponse {
  ok: true;
  logSorter: LogSorterResponse[];
}

export function useGetLogSorters() {
  const httpClient = useHttpClient();
  const languageStore = useLanguageStore();
  const { translations } = storeToRefs(languageStore);

  return {
    execute
  };

  async function execute() {

    const headers = httpClient.defaultHeaders();
    const request = new Request(httpClient.siteUrl(`logsorter/`), {
      headers,
      method: 'get'
    });

    const text = translations.value.logSorter.actions.fetch;

    const response = await httpClient.action<GetLogSortersSuccessResponse>(request, {
      title: text.title,
      errorTitle: text.error,
      async processOk(response) {
        const json = await response.json() as LogSorterResponse[];
        console.log('Fetched log sorters', { json });
        return {
          ok: true,
          logSorter: json
        };
      },
    });

    return response;
  }
}
